// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"

import Address from "./address"
import _content from "../../../content/layouts/footer.json"

const AddressFr = ({ langKey }) => {
  const { SeelkParis, AddressFr, PhoneNumberFr } = _content[langKey]

  return (
    <Address
      title={SeelkParis}
      paragraph1={AddressFr}
      paragraph2={PhoneNumberFr}
    />
  )
}

export default AddressFr
